import getPosition, { setWatchPosition } from './geolocation';

export default getPosition;
export { setWatchPosition };
